import { inject, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

/**
 * Marks a resource url as safe for use in Angular templates.
 */
@Pipe({
  name: 'safe',
})
export class SafePipe implements PipeTransform {
  private readonly domSanitizer = inject(DomSanitizer);

  transform(value: string) {
    return this.domSanitizer.bypassSecurityTrustResourceUrl(value);
  }
}
